const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getIncidents(orgId, filters = {}) {
  const params = new URLSearchParams();
  
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.siteId) params.append('siteId', filters.siteId);
  if (filters.assetId) params.append('assetId', filters.assetId);
  if (filters.type) params.append('type', filters.type);
  if (filters.status) params.append('status', filters.status);
  if (filters.severity) params.append('severity', filters.severity);
  if (filters.limit) params.append('limit', filters.limit);
  if (filters.offset) params.append('offset', filters.offset);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/incidents${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to view incidents');
    }
    throw new Error('Failed to fetch incidents');
  }
  
  return response.json();
}

export async function getIncident(orgId, incidentId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/incidents/${incidentId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Incident not found');
    }
    if (response.status === 403) {
      throw new Error('You do not have permission to view this incident');
    }
    throw new Error('Failed to fetch incident');
  }
  
  const data = await response.json();
  return data.incident;
}

export async function exportIncidentSummary(orgId, incidentId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/exports/incident-summary`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify({ incidentId })
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Incident not found');
    }
    throw new Error('Failed to export incident summary');
  }
  
  const data = await response.json();
  return data.exportJob;
}
